module.exports = __webpack_public_path__ + "img/352.b8c60912.jpg";